<template>
  <transition name="toast-fade">
    <div :class="type" class="global-toast" v-if="toastState.visible">
      {{ toastState.message }}
    </div>
  </transition>
</template>

<script setup>
import { toastService } from '@/utils/toastService'
import { isMobile } from '@/utils'

const type = isMobile ? 'mobile' : 'pc'
// 直接使用toastService中的状态
const toastState = toastService.getState()
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style> 